import { StyleSheet, Dimensions } from "react-native";

export default StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    flexDirection: "column",
    //alignItems: "flex-end",
    justifyContent: "flex-start",
  },
  loginContainer: {
    backgroundColor: "white",
    width: 380,
    height: 560,
    marginTop: 60,
    marginLeft: 658,
    paddingTop: 0,
    paddingBottom: 40,
    paddingLeft: 32,
    paddingRight: 32,
    borderRadius: 4,
    flex: "wrap",
    alignItems: "center",
    justifyContent: "center",
  },
  loginContainer_SMALL_MOBILE: { marginLeft: 0, width: 290 },
  loginContainer_MEDIUM_MOBILE: {
    marginLeft: 0,
    width: 350,
  },
  loginContainer_LARGE_MOBILE: { marginLeft: 0 },
  loginContainer_SMALL_TABLET: {
    marginLeft: 250,
  },
  loginContainer_MEDIUM_TABLET: {
    marginLeft: 400,
  },
  loginContainer_LARGE_TABLET: {
    marginLeft: 450,
  },
  inputField: {
    justifyContent: "space-between",
    flexDirection: "row",
    // alignSelf: 'flex-start',
    //marginLeft: 30,
    margin: 0,
    marginTop: 15,
  },
  header: {
    flexDirection: "row",
    alignSelf: "flex-start",
    //marginLeft: 30,
    marginBottom: 20,
  },
  headerText: {
    fontSize: 28,
    color: "#273a4e",
    fontWeight: "normal",
    fontFamily: "SFProText",
    fontSize: 28,
    marginLeft: 10,
  },
  idText: {
    fontSize: 14,
    color: "#273a4e",
    fontFamily: "SFProText",
    fontSize: 20,
  },
  passwordText: {
    alignSelf: "flex-start",
    fontSize: 14,
    color: "#273a4e",
    padding: 0,
    fontFamily: "SFProText",
    fontSize: 20,
  },

  containerForInput: {
    opacity: 1.0,
    flexDirection: "row",
    width: 300,
    height: 50,
    // marginLeft: 30,
    marginRight: 30,
    marginTop: 10,
    marginBottom: 10,
    backgroundColor: "#f5f5f5",
    borderRadius: 30,
    // backgroundColor:
    //   clickedLogin == false ? "rgba(63,183,245,1.0 )" : "#87CEEB",
  },
  containerForInput_SMALL_MOBILE: { width: 260 },
  containerForInput_MEDIUM_MOBILE: {},
  containerForInput_LARGE_MOBILE: {},

  logo: {
    position: "absolute",
    width: 111,
    height: 39,
    marginLeft: 10,
    top: 26,
    left: 32,
    right: 0,
    resizeMode: "contain",
  },

  inputView: {
    backgroundColor: "#FFC0CB",
    borderRadius: 30,
    width: "70%",
    height: 45,
    marginBottom: 20,

    alignItems: "center",
  },

  TextInput: {
    width: 316,
    color: "black",
    height: 50,
    backgroundColor: "#f5f5f5",
    borderRadius: 30,
    textAlign: "left",
    color: "black",
    paddingTop: 21,
    paddingRight: 110,
    paddingBottom: 20,
    paddingLeft: 30,
    fontFamily: "SFProText",
    fontSize: 16,
    fontWeight: "300",
  },
  TextInput_SMALL_MOBILE: {
    width: 260,
    fontSize: 12,
  },
  loginBtn: {
    opacity: 1.0,
    width: 316,
    height: 50,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 30,
    backgroundColor: "#f14d31",
    // paddingTop: 21,
    // paddingBottom: 20,
    marginTop: 30,
  },
  loginBtn_SMALL_MOBILE: {
    width: 260,
  },
  loginBtn_MEDIUM_MOBILE: {},
  loginText: {
    color: "white",
    fontFamily: "SFProText",
    fontSize: 16,
    fontWeight: "500",
  },
  support: {
    width: 40,
    height: 40,
  },
  loginView: {
    alignContent: "center",
    width: 316,
    height: 360,
  },
  loginView_SMALL_MOBILE: {
    alignContent: "center",
    width: 250,
    height: 360,
  },
});
